import React, { useState } from "react";
import { FaTimes } from "react-icons/fa";
import Backdrop from "../Backdrop";
import SideDrawer from "./SideDrawer";
import { Link } from "react-router-dom";
import Logo from '../../assets/images/logo.png'

import { IoMenuOutline } from "react-icons/io5";

const MobileNavbar = () => {
  const [drawerIsOpen, setDrawerIsOpen] = useState(false);
  const OpenDrawerHandler = () => {
    setDrawerIsOpen(true);
  };

  const closeDrawerHandler = () => {
    setDrawerIsOpen(false);
  };

  return (
    <>
      {drawerIsOpen && <Backdrop onClick={closeDrawerHandler} />}

      <SideDrawer show={drawerIsOpen}>
        <div className="mobile-navbar">
          <nav className="mobile-navigation-menu">
            <div className="menu-top title">
              <h2 className="menu-title">Menu</h2>

              <button className="menu-close-btn" onClick={closeDrawerHandler}>
                <FaTimes />
              </button>
            </div>

            <ul className="mobile-menu-category-list">
              <li className="menu-category">
                <Link
                  to="/"
                  className="menu-title"
                  onClick={closeDrawerHandler}
                >
                  Home
                </Link>
              </li>
              <li className="menu-category">
                <Link
                  to="/about"
                  className="menu-title"
                  onClick={closeDrawerHandler}
                >
                  About Us
                </Link>
              </li>
              
              <li className="menu-category">
                <Link
                  to="/books"
                  className="menu-title"
                  onClick={closeDrawerHandler}
                >
                  Books
                </Link>
              </li>

              <li className="menu-category">
                <Link
                  to="/about-app"
                  className="menu-title"
                  onClick={closeDrawerHandler}
                >
                  App
                </Link>
              </li>
              <li className="menu-category">
                <Link
                  to="/contact-us"
                  className="menu-title"
                  onClick={closeDrawerHandler}
                >
                  Contact Us
                </Link>
              </li>
            </ul>
          </nav>
        </div>
      </SideDrawer>

      <div className="mobile-navbar-heading">
        <p className="main-navigation__title">
          <Link to="/"><img src={Logo} alt="logo" width="80" height="70" /></Link>
        </p>

        <div className="mobile-bottom-navigation">
          <button className="action-btn" onClick={OpenDrawerHandler}>
            <IoMenuOutline />
          </button>
        </div>
      </div>
    </>
  );
};

export default MobileNavbar;
